/*
 * Copyright (c) 2026. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { fromGender } from "@/src/services/formServiceFunctions";

import React from "react";
import HighlightBox from "@/src/components/Box/HighlightBox/HighlightBox";
import { Box } from "@mui/material";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";

type PowerOfAttorneySignatoryHighlightBoxProps = {
  product: AbstractCase;
};

export default function PowerOfAttorneySignatoryHighlightBox({ product }: PowerOfAttorneySignatoryHighlightBoxProps) {
  if (product.clientIsCustomer) {
    return null;
  }

  return (
    <Box sx={{ marginTop: "1rem" }}>
      <HighlightBox headline={""}>
        {product.clientWasMinorAtContractDate &&
          (product.clientLegalRepresentativeAmount !== 2 ||
            (product.clientLegalRepresentativeAmount === 2 && product.clientLegalRepresentativesAuthorizationType === "individually")) &&
          `Achtung: Hier muss der gesetzliche Vertreter unterschreiben. In Ihrem Fall also: ${
            fromGender(product.clientLegalRepresentative.gender)
          } ${product.clientLegalRepresentative.givenName} ${product.clientLegalRepresentative.familyName}`}
        {product.clientWasMinorAtContractDate &&
          product.clientLegalRepresentativeAmount === 2 &&
          product.clientLegalRepresentativesAuthorizationType === "both" &&
          `Achtung: Hier müssen beide gesetzlichen Vertreter unterschreiben. In Ihrem Fall also:
                  ${fromGender(product.clientLegalRepresentative.gender)} ${product.clientLegalRepresentative.givenName} ${
            product.clientLegalRepresentative.familyName
          } und
                  ${fromGender(product.secondClientLegalRepresentative.gender)} ${product.secondClientLegalRepresentative.givenName} ${
            product.secondClientLegalRepresentative.familyName
          }`}
        {!product.clientWasMinorAtContractDate &&
          `Achtung: Hier muss die Person unterschreiben, die den Vertrag geschlossen hat. In Ihrem Fall also: ${
            fromGender(product.client.gender)
          } ${product.client.givenName} ${product.client.familyName}`}
      </HighlightBox>
    </Box>
  );
}
